// Bubima: +/- quantity selector on product cards, capped at available inventory.
const bubimaCartUrl = () => ((window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart') + '.js';

class BubimaCardQty extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.form = this.closest('form');
    this.input = this.querySelector('input[name="quantity"]');
    this.minusBtn = this.querySelector('[data-qty-minus]');
    this.plusBtn = this.querySelector('[data-qty-plus]');
    this.note = this.form ? this.form.querySelector('[data-qty-note]') : null;
    this.variantId = String(this.dataset.variantId);
    this.stock = parseInt(this.dataset.stock, 10) || 0;
    this.inCart = parseInt(this.dataset.inCart, 10) || 0;
    this.limited = this.dataset.limited === 'true';
    this.lastSync = 0;
    this.pending = null;

    const stop = (e) => { e.preventDefault(); e.stopPropagation(); };
    this.minusBtn.addEventListener('click', (e) => { stop(e); this.setValue(this.getValue() - 1); });
    this.plusBtn.addEventListener('click', (e) => { stop(e); this.setValue(this.getValue() + 1); });
    this.input.addEventListener('click', (e) => e.stopPropagation());
    this.input.addEventListener('change', () => this.setValue(this.getValue()));
    this.addEventListener('pointerenter', () => { if (Date.now() - this.lastSync > 5000) this.sync(); });

    if (this.form) {
      this.form.addEventListener('submit', () => {
        this.pending = { before: this.inCart, qty: this.getValue() };
        setTimeout(() => this.sync(), 1200);
      }, true);
    }
    this.render();
  }

  remaining() { return Math.max(0, this.stock - this.inCart); }

  getValue() {
    const v = parseInt(this.input.value, 10);
    return isNaN(v) ? 1 : v;
  }

  setValue(v) {
    const max = Math.max(1, this.remaining());
    this.input.value = String(Math.min(Math.max(1, v), max));
    this.render();
  }

  addButton() { return this.form ? this.form.querySelector('[ref="addToCartButton"]') : null; }

  setNote(text) {
    if (!this.note) return;
    this.note.textContent = text;
    this.note.hidden = !text;
  }

  render(message) {
    const rem = this.remaining();
    const val = this.getValue();
    const available = this.dataset.available === 'true';
    const blocked = !available || rem <= 0;
    this.minusBtn.disabled = blocked || val <= 1;
    this.plusBtn.disabled = blocked || val >= rem;
    this.input.disabled = blocked;
    this.input.max = String(Math.max(1, rem));
    const btn = this.addButton();
    if (btn) btn.disabled = blocked;
    if (message) return this.setNote(message);
    if (!available) this.setNote('');
    else if (rem <= 0) this.setNote('כל הכמות הזמינה כבר בסל');
    else if (this.limited && val >= rem) this.setNote(rem === 1 ? 'נשארה יחידה אחרונה' : 'ניתן להזמין עד ' + rem + ' יחידות');
    else this.setNote('');
  }

  async sync() {
    this.lastSync = Date.now();
    try {
      const res = await fetch(bubimaCartUrl(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      this.inCart = cart.items
        .filter((i) => String(i.variant_id) === this.variantId)
        .reduce((sum, i) => sum + i.quantity, 0);
      let msg = '';
      if (this.pending) {
        if (this.inCart < this.pending.before + this.pending.qty) {
          msg = 'לא ניתן להוסיף את כל הכמות – אין מספיק במלאי';
        }
        this.pending = null;
        this.input.value = '1';
      }
      this.setValue(this.getValue());
      if (msg) this.render(msg);
    } catch (e) {
      /* network issue: keep current state */
    }
  }
}

if (!customElements.get('bubima-card-qty')) {
  customElements.define('bubima-card-qty', BubimaCardQty);
}
